import { WateringCanOutlineIcon } from './WateringCanOutlineIcon';

/**
 * author: guenth39
 * id 67419E50-B2CE-4B36-A137-705FD6404252
 * name watering-can-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/watering-can-outline.svg
 * tags
 * - Agriculture 
 */
export const WateringPotOutlineIcon = WateringCanOutlineIcon;
export default WateringPotOutlineIcon